import { IConfig } from './security.service';

export interface User {
  id: number;
  name: string;
  login: string;
  email?: string;
  profile?: string;
  roles?: string[];
  contextId?: string;
  context?: boolean;
  isRoot?: boolean;
  expiresIn: number;
  /**
   * Instante (epoch ms) em que o access token expira. Calculado a partir de
   * `expiresIn` no momento em que a credencial é gravada — diferente de
   * `expiresIn`, sobrevive a recarregamentos da página e permite saber, ao
   * voltar para a aba, se a sessão ainda está de pé. Credenciais gravadas por
   * versões anteriores não têm o campo e são tratadas como expiradas.
   */
  expiresAt?: number;
  accessToken: string;
  refreshToken: string;
  userContextId?: string;
  expiredPassword?: boolean;
  /**
   * Falso quando o usuário é apenas agente (sem vínculo de gestão). O login
   * acontece, mas só dá acesso ao cadastro da própria empresa — nunca às telas
   * de gestão. Ausente/undefined significa acesso normal, preservando o
   * comportamento de todo token emitido antes desta versão.
   */
  panelAccess?: boolean;
}

export class Credential {
  private current?: User;

  constructor(private config: IConfig) {}

  public init(user?: User): void {
    this.current = user;

    if (this.current) {
      let data = JSON.stringify(this.current);
      localStorage.setItem(this.config.storage, btoa(data));
    } else {
      let data = localStorage.getItem(this.config.storage);

      if (data) {
        data = atob(data);
        this.current = JSON.parse(data);
      }
    }
  }

  public clean(): void {
    this.current = undefined;
    localStorage.removeItem(this.config.storage);
  }

  public get user(): User | undefined {
    return this.current;
  }

  public get username(): string {
    return this.current?.name || '';
  }

  public get login(): string {
    return this.current?.login || '';
  }

  public get accessToken(): string {
    return this.current?.accessToken || '';
  }

  public get roles(): string[] {
    return this.current?.roles || [];
  }

  public get refreshToken(): string {
    return this.current?.refreshToken || '';
  }

  public get expiresAt(): number {
    return this.current?.expiresAt || 0;
  }

  public get expiredPassword(): boolean {
    return this.current?.expiredPassword || false;
  }

  /**
   * Indica se a credencial abre as telas do painel. Ausência do valor equivale
   * a `true` — só o token restrito do agente traz `false` explicitamente.
   */
  public get panelAccess(): boolean {
    return this.current?.panelAccess !== false;
  }
}
